export default {
    alarm: {
        default_layer: '默认层级',
        alarm_object: '报警对象',
        alarm_mail: '邮件报警',
        alarm_msg: '短信报警',
        alarm_phone: '语音报警',
        alarm_cause: '报警原因',
        alarm_time: '报警时间',
        repeat_times: '重复次数',
        repeat_interval: '重复间隔',
        alarm_repeat: '重复报警',
        alarm: '报警',
        empty_time: '报警时间、时间点不能为空',
        open: '报警开启',
        close: '报警关闭',
        add_trigger: '新增触发器',
        alarm_switch: '报警开关'
    }
};
